class User {
    isLoggedIn = () => this.get('isLoggedIn') === 'true';
  
    set = (key, value) => localStorage.setItem(key, value);
  
    get = key => this.getLocalStorage(key);
  
    getLocalStorage = key => {
      const ret = localStorage.getItem(key);
      if (ret) {
        return ret;
      }
      return null;
    };
  
    login = async (email, password) => {
      // ログイン処理
      this.set('isLoggedIn', true);
      return true;
    };
  
    logout = async () => {
      if (this.isLoggedIn()) {
        // ログアウト処理
        this.set('isLoggedIn', false);
        localStorage.removeItem("datalist");
      }
    };
  }
  
  export default new User();